import React from 'react';
import './Footer.css'; // Assuming you will create a Footer.css for specific styles

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} Prefeitura de Monsenhor Gil. Todos os direitos reservados.</p>
                <ul className="footer-links">
                    <li><a href="/semgi/login">Protocolo</a></li>
                    <li><a href="/processo-administrativo">Processo Administrativo</a></li>
                    <li><a href="/patrimonio">Patrimônio</a></li>
                    <li><a href="/secretarias">Secretarias</a></li>
                    <li><a href="/legislacao">Legislação</a></li>
                    <li><a href="/servidores">Servidores</a></li>
                </ul>
            </div>
        </footer>
    );
};

export default Footer;